export function copyToClipboard(data) {
  navigator.clipboard.writeText(data);
}
